import { render, staticRenderFns } from "./Kitob.vue?vue&type=template&id=35614738&scoped=true"
import script from "./Kitob.vue?vue&type=script&lang=js"
export * from "./Kitob.vue?vue&type=script&lang=js"
import style0 from "./Kitob.vue?vue&type=style&index=0&id=35614738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35614738",
  null
  
)

export default component.exports